import { z } from 'zod';
import { Decimal } from './money.js';
/**
 * Tasas: string decimal con 6 decimales (`"0.452100"` = 45,21 % EA). Arquitectura §6.
 * Este helper solo parsea, compara y formatea. **Las conversiones EA↔MV y cualquier cálculo
 * financiero viven en `packages/credit-math`.**
 */
export const DECIMAL_6_PATTERN = /^\d{1,3}\.\d{6}$/;
export const RateSchema = z
    .string()
    .regex(DECIMAL_6_PATTERN, 'Debe ser una tasa decimal con 6 decimales, p. ej. "0.452100"')
    .meta({
    id: 'Rate',
    description: 'Tasa como fracción decimal con 6 decimales ("0.452100" = 45,21 %).',
});
export class Rate {
    #value;
    constructor(value) {
        if (value.isNegative())
            throw new RangeError('La tasa no puede ser negativa');
        this.#value = value.toDecimalPlaces(6, Decimal.ROUND_HALF_UP);
    }
    static of(value) {
        if (typeof value === 'string' && !/^\d+(\.\d+)?$/.test(value)) {
            throw new TypeError(`Tasa inválida: "${value}"`);
        }
        return new Rate(new Decimal(value));
    }
    /** Desde porcentaje en string: `"45.21"` → `0.452100`. */
    static fromPercent(percent) {
        return new Rate(new Decimal(percent).div(100));
    }
    static zero() {
        return new Rate(new Decimal(0));
    }
    toDecimal() {
        return new Decimal(this.#value);
    }
    toString() {
        return this.#value.toFixed(6);
    }
    toJSON() {
        return this.toString();
    }
    eq(other) {
        return this.#value.eq(other.#value);
    }
    gt(other) {
        return this.#value.gt(other.#value);
    }
    lte(other) {
        return this.#value.lte(other.#value);
    }
    /** `"45,21 %"` (es-CO). */
    formatPercent(decimals = 2) {
        return `${this.#value.times(100).toFixed(decimals).replace('.', ',')} %`;
    }
}
//# sourceMappingURL=rate.js.map